import { v4 as uuidv4 } from 'uuid';

export function MinicartEmptyState(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'MinicartEmptyState',
		componentId: uuidv4(),
		props,
		childrenComponents,
		blocks,
	};
}
